// Add your custom JS here.

(function ($) {
    function checkHeight(ele) {
        var h = 0;
        $(ele).each(function () {
            if ($(this).height() > h) {
                h = $(this).height();
            }
        });
        $(ele).css('height', h + 'px');
    }

    function setFullHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }

    window.addEventListener('resize', setFullHeight);
    setFullHeight();

    $(document).ready(function () {

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 100) {
                $('.toTop').addClass('active');
            } else {
                $('.toTop').removeClass('active');
            }
        });

        $('.toTop').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'swing');
        });



        $(document).on('click', '.openMenu', function (e) {
            e.preventDefault();
            console.log('nhmmmm');
            $('.header__mobi').addClass('active').css('display', 'flex');
            $('.header-overlay').addClass('active');
        });

        $(document).on('click', '.closeMenu, .header-overlay', function (e) {
            e.preventDefault();
            $('.header__mobi').removeClass('active').css('display', 'none');
            $('.header-overlay').removeClass('active');
        });

        if ($('.header').length) {
            // 1. Lưu trữ các bộ chọn
            const $headerOverlay = $('.header-overlay');
            const $logo = $('.header__logo img'); // <-- Thêm bộ chọn logo

            // 2. Định nghĩa các giá trị
            const scrollDistance = 300; // Khoảng cách cuộn để hoàn thành hiệu ứng

            const startHeight = 50; // Chiều cao logo ban đầu (desktop)
            const endHeight = 40;   // Chiều cao logo cuối cùng
            const heightDifference = startHeight - endHeight; // (70 - 50 = 20)

            $(window).on('scroll', function () {
                // Lấy vị trí cuộn dọc hiện tại
                const scrollY = $(window).scrollTop();

                // Tính toán tỷ lệ cuộn (từ 0 đến 1)
                let scrollFraction = scrollY / scrollDistance;
                if (scrollFraction > 1) {
                    scrollFraction = 1;
                }

                // --- Logic 1: Cập nhật Opacity cho Overlay ---
                // (Giữ nguyên như cũ, chỉ dùng scrollFraction)
                $headerOverlay.css('opacity', scrollFraction);

                // --- Logic 2: Cập nhật Height cho Logo ---
                // newHeight = 70 - (20 * tỷ_lệ_cuộn)
                const newHeight = startHeight - (heightDifference * scrollFraction);

                // Áp dụng chiều cao mới cho logo
                $logo.css('height', newHeight + 'px');
                $logo.css('max-height', newHeight + 'px');
            });
        }

        $(document).on('click', '.selectPostType', function (e) {
            e.preventDefault();
            $('.postTypeDropdown').toggleClass('show');
        });

        if ($('.itemPostType').length) {
            $('.itemPostType').each(function () {
                if ($(this).hasClass('active')) {
                    const text = $(this).text();
                    $('.selectPostType .text').text(text);
                }
            });
            $(document).on('click', '.itemPostType', function (e) {
                e.preventDefault();
                const text = $(this).text();
                const postType = $(this).data('posttype');
                const icon = $(this).data('icon');
                $(this).addClass('active').siblings('.itemPostType').removeClass('active').closest('.postTypeDropdown').removeClass('show');
                $('.selectPostType .text').text(text);
                $('.selectPostType i').attr('class', icon);
                $('input[name="post_type"]').val(postType).trigger('change');

                if (postType != 'hotel') {
                    $('.formDate').removeClass('d-flex').addClass('d-none');
                    $('#check_in, #check_out').prop('disabled', true);
                } else {
                    $('.formDate').removeClass('d-none').addClass('d-flex');
                    $('#check_in, #check_out').prop('disabled', false);
                }
            });
        }

        if ($('input[name="s"]').length) {
            if ($('.hotelSearch__form, .cruiseSearch__form').find('input[name="post_type"]').val() != 'hotel') {
                $('input[name="s"]').autocomplete({
                    source: function (request, response) {
                        let postTypeVal = $('input[name="post_type"]').val();
                        $.ajax({
                            url: ajax_object.ajax_url,
                            type: 'POST',
                            dataType: 'json',
                            data: {
                                action: 'autocomplete_hotel', // Tên action trong functions.php
                                term: request.term,
                                post_type: postTypeVal
                            },
                            success: function (data) {
                                // Kiểm tra nếu không có kết quả thì trả về mảng rỗng
                                if (!data.length) {
                                    var noResult = [{
                                        label: "No information found",
                                        value: request.term,
                                        disabled: true // Thêm thuộc tính để không thể chọn được
                                    }];
                                    response(noResult);
                                } else {
                                    response(data);
                                }
                            }
                        });
                    },
                    minLength: 2, // Bắt đầu tìm kiếm khi người dùng gõ từ 2 ký tự
                    select: function (event, ui) {
                        // Ngăn hành động mặc định
                        event.preventDefault();

                        // Nếu mục được chọn là "Không tìm thấy...", thì không làm gì cả
                        if (ui.item.disabled) {
                            return false;
                        }

                        // Lấy tiêu đề của khóa học được chọn
                        var selectedTitle = ui.item.value;

                        // Đặt tiêu đề đó vào ô tìm kiếm
                        $('input[name="s"]').val(selectedTitle);
                    }
                }).data("ui-autocomplete")._renderItem = function (ul, item) {
                    // Tùy chỉnh cách hiển thị từng mục gợi ý
                    // Thêm class 'ui-state-disabled' cho mục "Không tìm thấy"
                    var listItem = $("<li>");
                    if (item.disabled) {
                        listItem.addClass("ui-state-disabled");
                    }
                    listItem.append("<div>" + item.label + "</div>").appendTo(ul);
                    return listItem;
                };
            } else {
                let debounce_search_timer;
                let current_ajax_search_request;

                //Hàm xử lý tìm kiếm khách sạn
                function handleSearchHotel(keyword = '') {
                    if (current_ajax_search_request) {
                        current_ajax_search_request.abort();
                    }

                    current_ajax_search_request = $.ajax({
                        url: ajax_object.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'search_hotel_action',
                            nonce: ajax_object.nonce,
                            keyword: keyword,
                        },
                        beforeSend: function () {
                            $('.dropResult__inner').html('<p>Searching...</p>');
                        },
                        success: function (response) {
                            if (response.data) {
                                $('.dropResult__inner').html(response.data);
                            } else {
                                $('.dropResult__inner').html('<p>No results found...</p>');
                            }
                        },
                        error: function (jqXHR, textStatus) {
                            // Không báo lỗi nếu request bị chúng ta chủ động hủy
                            if (textStatus !== 'abort') {
                                console.error("AJAX Error: " + textStatus);
                            }
                            $('.dropResult__inner').html('<p>No results found...</p>');
                        },
                        complete: function () {
                            // Dọn dẹp biến khi request hoàn thành (dù thành công hay thất bại)
                            current_ajax_request = null;
                        }
                    });
                }
                $('input[name="s"]').on('focus', function () {
                    $('#dropResult').addClass('show');
                }).on('input', function () {
                    // Xóa bộ đếm thời gian cũ
                    clearTimeout(debounce_search_timer);
                    const keyword = $(this).val();
                    if (keyword.length >= 2) {
                        // Đặt bộ đếm thời gian mới. Hàm fetch_filtered sẽ chỉ chạy sau 500ms
                        // kể từ lần cuối cùng người dùng tương tác với bộ lọc.
                        debounce_search_timer = setTimeout(function () {
                            // Khi người dùng thay đổi filter, luôn quay về trang 1
                            handleSearchHotel(keyword);
                        }, 500); // 500ms là một khoảng thời gian hợp lý
                    }
                });

                $(document).on('click', function (e) {
                    // Kiểm tra xem mục tiêu có phải là ô input không
                    const isSearchInput = $(e.target).closest('input[name="s"]').length > 0;

                    // Kiểm tra xem mục tiêu có nằm trong .dropResult không
                    const isInsideDropdown = $(e.target).closest('.dropResult').length > 0;

                    // Nếu nhấp chuột KHÔNG phải là ô input VÀ KHÔNG nằm trong dropdown
                    if (!isSearchInput && !isInsideDropdown) {
                        $('#dropResult').removeClass('show'); // Thì mới ẩn dropdown
                    }
                });
            }
        }

        // JS form search
        // =================================================================
        // BƯỚC 1: LẤY VÀ XỬ LÝ NGÀY THÁNG TỪ URL
        // =================================================================
        const urlParams = new URLSearchParams(window.location.search);
        const checkInParam = urlParams.get('check_in');
        const checkOutParam = urlParams.get('check_out');

        // Đặt giá trị mặc định là hôm nay và ngày mai
        let startDate = moment();
        let endDate = moment().add(1, 'days');

        // Nếu có tham số trên URL, chuyển đổi và gán lại giá trị
        // Định dạng 'dd, DD MMMM' khớp với 'Th, 09 October'
        if (checkInParam) {
            startDate = moment(checkInParam, 'dd, DD MMMM');
        }
        if (checkOutParam) {
            endDate = moment(checkOutParam, 'dd, DD MMMM');
        }

        // =================================================================
        // BƯỚC 2: TẠO HÀM CẬP NHẬT GIAO DIỆN
        // (Tách ra để có thể tái sử dụng)
        // =================================================================
        function updateDateDisplay(start, end) {
            var titleFrom = "Check in: " + start.format('dd, DD MMMM');
            var titleTo = "Check out: " + end.format('dd, DD MMMM');
            $('.drp-selected').html(titleFrom + ' - ' + titleTo);

            var formattedStartDate = start.format('dd, DD MMMM');
            var formattedEndDate = end.format('dd, DD MMMM');

            $('#check_in').val(formattedStartDate);
            $('#check_out').val(formattedEndDate);

            $('.checkIn_val').text(formattedStartDate);
            $('.checkOut_val').text(formattedEndDate);
        }

        // =================================================================
        // BƯỚC 3: KHỞI TẠO DATERANGEPICKER
        // =================================================================
        // Tạo một đối tượng cấu hình chung
        let daterangepickerOptions = {
            autoUpdateInput: false,
            locale: {
                cancelLabel: 'Clear',
                format: 'DD/MM/YYYY',
                firstDay: 1,
                fromLabel: "Check in",
                toLabel: "Check out",
            },
            minDate: new Date(),
            startDate: startDate, // <-- Dùng biến đã xử lý ở trên
            endDate: endDate,     // <-- Dùng biến đã xử lý ở trên
        };

        // Điều chỉnh cấu hình dựa trên kích thước màn hình
        if ($(window).width() < 767) {
            daterangepickerOptions.autoApply = false;
        } else {
            daterangepickerOptions.autoApply = true;
        }

        // Khởi tạo daterangepicker với cấu hình và hàm callback
        $('.date-picker').daterangepicker(daterangepickerOptions, updateDateDisplay);

        // =================================================================
        // BƯỚC 4: CẬP NHẬT HIỂN THỊ BAN ĐẦU NẾU CÓ URL PARAMS
        // =================================================================
        if (checkInParam && checkOutParam) {
            // Gọi hàm để hiển thị ngày tháng từ URL lên giao diện ngay khi tải trang
            updateDateDisplay(startDate, endDate);
        }
        /**=========================================================================== */


        if ($('.filter__price').length) {
            /**
             * Xử lý input range khoảng giá
             */
            const minSlider = $('#min-slider');
            const maxSlider = $('#max-slider');
            const minValueDisplay = $('#min-value');
            const maxValueDisplay = $('#max-value');
            const fillTrack = $('.slider-fill-track');
            const minGap = 0;
            const maxRangeValue = parseFloat(minSlider.prop('max'));

            function updateSliders() {
                let minVal = parseFloat(minSlider.val());
                let maxVal = parseFloat(maxSlider.val());

                if (maxVal - minVal < minGap) {
                    if ($(this).attr('id') === 'min-slider') {
                        minSlider.val(maxVal - minGap);
                        minVal = maxVal - minGap;
                    } else {
                        maxSlider.val(minVal + minGap);
                        maxVal = minVal + minGap;
                    }
                }

                const minPercent = (minVal / maxRangeValue) * 100;
                const maxPercent = (maxVal / maxRangeValue) * 100;

                fillTrack.css({
                    'left': minPercent + '%',
                    'width': (maxPercent - minPercent) + '%'
                });

                const locale = 'en-US';
                const nf = new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
                minValueDisplay.text(nf.format(minVal) + ' USD');
                maxValueDisplay.text(nf.format(maxVal) + ' USD');
            }

            minSlider.on('input', updateSliders);
            maxSlider.on('input', updateSliders);
            updateSliders();
        }


        /**
         * Xử lý ajax lọc
         */
        // Biến để lưu trữ bộ đếm thời gian debounce
        let debounce_timer;

        // Biến để lưu trữ request AJAX đang chạy
        let current_ajax_request;

        /**
         * Hàm xử lý ajax filter
         */
        function fetch_filtered(page_number = 1) {

            // 1. HỦY REQUEST CŨ (NẾU CÓ)
            // Điều này ngăn chặn race condition, đảm bảo chỉ request cuối cùng được xử lý.
            if (current_ajax_request) {
                current_ajax_request.abort();
            }

            var filter_data = $('#filter-form').serialize();

            // Gán request AJAX mới vào biến
            current_ajax_request = $.ajax({
                url: ajax_object.ajax_url,
                type: 'POST',
                data: {
                    action: 'filter_action',
                    nonce: ajax_object.nonce,
                    filter_data: filter_data,
                    page: page_number, // Gửi số trang như một tham số riêng, sạch sẽ hơn
                },
                beforeSend: function () {
                    $('.resultBar__count').text('Searching...');
                },
                success: function (response) {
                    if (response.data.count && response.data.count > 0) {
                        $('.resultBar__count').text(`There are ${response.data.count} results found`);
                        $('#resultMain').html(response.data.html);
                    } else {
                        $('.resultBar__count').text(`No results found`);
                        $('#resultMain').html('');
                    }
                },
                error: function (jqXHR, textStatus) {
                    // Không báo lỗi nếu request bị chúng ta chủ động hủy
                    if (textStatus !== 'abort') {
                        console.error("AJAX Error: " + textStatus);
                    }
                    $('.resultBar__count').text('No results found');
                },
                complete: function () {
                    // Dọn dẹp biến khi request hoàn thành (dù thành công hay thất bại)
                    current_ajax_request = null;
                }
            });
        }

        // 2. KẾT HỢP CÁC EVENT HANDLER VÀ ÁP DỤNG DEBOUNCE
        $('#filter-form').on('change mouseup touchend', 'input, select', function () {

            // Xóa bộ đếm thời gian cũ
            clearTimeout(debounce_timer);

            // Đặt bộ đếm thời gian mới. Hàm fetch_filtered sẽ chỉ chạy sau 500ms
            // kể từ lần cuối cùng người dùng tương tác với bộ lọc.
            debounce_timer = setTimeout(function () {
                // Khi người dùng thay đổi filter, luôn quay về trang 1
                fetch_filtered(1);
            }, 500); // 500ms là một khoảng thời gian hợp lý
        });

        // 3. XỬ LÝ PHÂN TRANG (CHẠY NGAY LẬP TỨC)
        // Gọi hàm fetch_filtered đã được tối ưu
        // và sẽ hủy bất kỳ request filter nào đang chờ.
        $(document).on('click', '#resultMain .page-link', function (e) {
            e.preventDefault();

            // Hủy bộ đếm thời gian debounce nếu người dùng nhấn phân trang ngay sau khi lọc
            clearTimeout(debounce_timer);

            const page_url = $(this).attr('href');

            // Cải thiện việc lấy số trang để an toàn hơn
            const page_number_match = page_url.match(/\/page\/(\d+)/);
            const page_number = page_number_match ? page_number_match[1] : 1;

            // Gọi hàm fetch ngay lập tức, không qua debounce
            fetch_filtered(page_number);

            const intoViewTop = $('.searchResult__main').offset().top - $('.header').outerHeight() - 16;
            $('html, body').animate({
                scrollTop: intoViewTop,
            }, 300);
        });

        $('#sortResult').on('change', function () {
            const sortby = $(this).val();
            fetch_filtered(1, sortby);
        });

        $(document).on('click', '.js-highlight', function (e) {
            e.preventDefault();
            $(this).toggleClass('show').siblings('.js-highlight-content').slideToggle(300);
        });

        if ($('#comment-filter-form').length) {
            // Bắt sự kiện khi người dùng thay đổi bất kỳ dropdown nào trong form
            $('#comment-filter-form').on('change', function (e) {
                e.preventDefault();

                const form = $(this);
                const commentsContainer = $('.reviewResult');

                // Lấy dữ liệu từ form và post_id
                const formData = form.serialize();

                $.ajax({
                    url: ajax_object.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'filter_comments', // Tên action đã đăng ký trong PHP
                        nonce: ajax_object.nonce,
                        form_data: formData
                    },
                    beforeSend: function () {
                        // Thêm hiệu ứng loading
                        form.find('select').prop('disabled', true);
                        commentsContainer.css('opacity', 0.5);
                    },
                    success: function (response) {
                        if (response.success) {
                            // Cập nhật lại HTML của danh sách bình luận
                            commentsContainer.html(response.data.html);
                        } else {
                            commentsContainer.html('<p>An error occurred.</p>');
                        }
                    },
                    error: function () {
                        commentsContainer.html('<p>An error occurred while filtering.</p>');
                    },
                    complete: function () {
                        // Bỏ hiệu ứng loading
                        form.find('select').prop('disabled', false);
                        commentsContainer.css('opacity', 1);
                    }
                });
            });
        }

        if ($('#comment-success-toast').length) {
            // Lấy các tham số từ URL hiện tại
            const urlParams = new URLSearchParams(window.location.search);
            const commentStatus = urlParams.get('comment_status');

            // Nếu tham số 'comment_status' tồn tại
            if (commentStatus) {
                const toastEl = $('#comment-success-toast');
                const toastBody = toastEl.find('.toast-body');
                let message = '';

                // Chọn nội dung thông báo dựa trên trạng thái
                if (commentStatus === 'approved') {
                    message = 'Add review successfully';
                } else if (commentStatus === 'pending') {
                    message = 'Added successfully, review pending approval';
                }

                // Nếu có nội dung, cập nhật và hiển thị Toast
                if (message && toastEl) {
                    toastBody.text(message);

                    toastEl.toast('show');
                }
            }
        }

        if ($('#booktour-success-toast').length) {
            const urlParams = new URLSearchParams(window.location.search);
            const bookingStatus = urlParams.get('booking_success');

            if (bookingStatus) {
                const toastEl = $('#booktour-success-toast');
                const toastBody = toastEl.find('.toast-body');
                let message = '';

                if (bookingStatus == 1) {
                    message = 'Tour booking successful. We will contact you as soon as possible.';
                } else {
                    message = 'The system is having some problems, please try again later.';
                }

                if (message && toastEl.length) {
                    toastBody.text(message);
                    toastEl.toast('show');
                }
            }
        }

        if ($('#bookpackage-success-toast').length) {
            // Lấy các tham số từ URL hiện tại
            const urlParams = new URLSearchParams(window.location.search);
            const bookingStatus = urlParams.get('booking_success');

            if (bookingStatus) {
                const toastEl = $('#bookpackage-success-toast');
                const toastBody = toastEl.find('.toast-body');
                let message = '';

                // Chọn nội dung thông báo dựa trên trạng thái
                if (bookingStatus == 1) {
                    message = 'Package booking successful. We will contact you as soon as possible.';
                } else {
                    message = 'The system is having some problems, please try again later.';
                }

                // Nếu có nội dung, cập nhật và hiển thị Toast
                if (message && toastEl.length) {
                    toastBody.text(message);
                    toastEl.toast('show');
                }
            }
        }

        //Slider main
        if ($('.heroSlider__main').length) {
            const heroSlider = new Swiper('.heroSlider__main', {
                // Kích hoạt hiệu ứng Fade
                effect: 'fade',
                fadeEffect: {
                    crossFade: true // Quan trọng để 2 slide (đang vào và đang ra) hiển thị cùng lúc trong quá trình fade
                },
                autoplay: {
                    delay: 7000,
                    disableOnInteraction: false,
                },
                speed: 1800, // Tốc độ chuyển slide (fade) tính bằng mili giây

                loop: true, // Lặp lại slide
                pagination: false,
                navigation: false,

                on: {
                    // Sự kiện này kích hoạt NGAY TRƯỚC KHI quá trình chuyển slide bắt đầu
                    beforeTransitionStart: function (swiperInstance) {
                        // `swiperInstance.activeIndex` là index của slide SẼ trở thành active
                        const incomingSlide = swiperInstance.slides[swiperInstance.activeIndex];
                        const incomingImage = incomingSlide?.querySelector('img');

                        if (incomingImage) {
                            // Thêm class để hình ảnh của slide SẮP HIỂN THỊ zoom ra
                            incomingImage.classList.add('is-zoomed-out');
                        }

                        // Đảm bảo các ảnh khác (nếu có) không còn class này (quan trọng với loop và các tương tác nhanh)
                        swiperInstance.slides.forEach((slide, index) => {
                            if (index !== swiperInstance.activeIndex) { // Bỏ qua slide sắp active
                                const img = slide.querySelector('img');
                                if (img && img !== incomingImage) { // Thêm điều kiện img !== incomingImage để chắc chắn
                                    // Nếu muốn slide đang ẩn đi cũng zoom theo kiểu khác thì thêm class ở đây
                                    // Còn nếu chỉ muốn nó về bình thường thì có thể không cần làm gì ở đây,
                                    // vì slideChangeTransitionEnd sẽ dọn dẹp.
                                }
                            }
                        });
                    },

                    // Sự kiện này kích hoạt KHI quá trình chuyển slide (fade) KẾT THÚC
                    slideChangeTransitionEnd: function (swiperInstance) {
                        // `swiperInstance.activeIndex` là index của slide HIỆN TẠI đang active
                        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
                        const activeImage = activeSlide?.querySelector('img');

                        if (activeImage) {
                            // Xóa class để hình ảnh của slide VỪA HIỂN THỊ XONG zoom trở lại (vào)
                            activeImage.classList.remove('is-zoomed-out');
                        }

                        // Dọn dẹp class 'is-zoomed-out' khỏi tất cả các ảnh không active
                        // Điều này đảm bảo trạng thái đúng khi người dùng điều hướng nhanh hoặc lặp slide
                        swiperInstance.slides.forEach((slide, index) => {
                            if (index !== swiperInstance.activeIndex) {
                                const img = slide.querySelector('img');
                                if (img) {
                                    img.classList.remove('is-zoomed-out');
                                }
                            }
                        });
                    },

                    // Xử lý cho slide đầu tiên khi Swiper khởi tạo (để nó không bị zoom sẵn)
                    init: function (swiperInstance) {
                        const initialActiveSlide = swiperInstance.slides[swiperInstance.activeIndex];
                        const initialActiveImage = initialActiveSlide?.querySelector('img');
                        if (initialActiveImage) {
                            initialActiveImage.classList.remove('is-zoomed-out');
                        }
                    }
                }
            });
        }

        if ($('.homeLocation__slider').length) {
            const homeLocation__slider = new Swiper('.homeLocation__slider', {
                slidesPerView: 4,
                spaceBetween: 100,
                navigation: false,
                pagination: false,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.3,
                        spaceBetween: 8
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.3,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 12
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 4,
                        spaceBetween: 36
                    }
                }
            });
        }

        if ($('.hotelBanner__slider, .cruiseBanner__slider').length) {
            const hotelBanner__slider = new Swiper('.hotelBanner__slider, .cruiseBanner__slider', {
                slidesPerView: 3,
                spaceBetween: 5,
                navigation: false,
                pagination: false,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 5
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.2,
                        spaceBetween: 5
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 5
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 3,
                        spaceBetween: 5
                    }
                }
            });
            $('.hotelBanner__slider, .cruiseBanner__slider').on('mouseenter', () => {
                hotelBanner__slider.autoplay.stop(); // Stop autoplay
            }).on('mouseleave', () => {
                hotelBanner__slider.autoplay.start(); // Resume autoplay
            });
        }

        if ($('.hotelLocation__slider, .cruiseLocation__slider').length) {
            const hotelLocation__slider = new Swiper('.hotelLocation__slider, .cruiseLocation__slider', {
                slidesPerView: 4,
                spaceBetween: 20,
                navigation: false,
                pagination: false,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 20
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.2,
                        spaceBetween: 20
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 4,
                        spaceBetween: 20
                    }
                }
            });
            $('.hotelLocation__slider, .cruiseLocation__slider').on('mouseenter', () => {
                hotelLocation__slider.autoplay.stop(); // Stop autoplay
            }).on('mouseleave', () => {
                hotelLocation__slider.autoplay.start(); // Resume autoplay
            });
        }

        if ($('.secNav--slider').length) {
            const secNav = new Swiper('.secNav--slider', {
                slidesPerView: 'auto',
                spaceBetween: 24,
                navigation: false,
                pagination: false,
                autoplay: false,
                // speed: 500,
                loop: false,
                mousewheel: true,
                waitForTransition: false,
            });
        }

        if ($('.homeFeedback__slider').length) {
            new Swiper('.homeFeedback__slider', {
                slidesPerView: 1,
                spaceBetween: 20,
                watchOverflow: true,
                navigation: {
                    nextEl: '.homeFeedback__sliderWrap .swiper-button-next',
                    prevEl: '.homeFeedback__sliderWrap .swiper-button-prev',
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1.15,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                },
            });
        }

        $(document).on('click', '.js-homeFeedback-readmore', function () {
            const $btn = $(this);
            const $card = $btn.closest('.homeFeedback__card');
            const expanded = !$card.hasClass('is-expanded');
            $card.toggleClass('is-expanded', expanded);
            $btn.attr('aria-expanded', expanded);
            const readMore =
                typeof goldenholidaytravelHomeFeedback !== 'undefined' && goldenholidaytravelHomeFeedback.readMore
                    ? goldenholidaytravelHomeFeedback.readMore
                    : 'Read more';
            const readLess =
                typeof goldenholidaytravelHomeFeedback !== 'undefined' && goldenholidaytravelHomeFeedback.readLess
                    ? goldenholidaytravelHomeFeedback.readLess
                    : 'Read less';
            $btn.text(expanded ? readLess : readMore);
        });

        if ($('.packageHotel').length) {
            const packageHotel = new Swiper('.packageHotel', {
                slidesPerView: 4,
                spaceBetween: 20,
                navigation: false,
                pagination: false,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1.2,
                        spaceBetween: 20
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1.2,
                        spaceBetween: 20
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    // when window width is >= 640px
                    991: {
                        slidesPerView: 4,
                        spaceBetween: 20
                    }
                }
            });
            $('.packageHotel').on('mouseenter', () => {
                packageHotel.autoplay.stop(); // Stop autoplay
            }).on('mouseleave', () => {
                packageHotel.autoplay.start(); // Resume autoplay
            });
        }

        if ($('.tourGallery__main').length && $('.tourGallery__thumbs').length) {
            const tourThumbs = new Swiper(".tourGallery .tourGallery__thumbs", {
                spaceBetween: 10,
                slidesPerView: "auto",
                freeMode: true,
                watchSlidesProgress: true,
            });
            const tourGalleryMain = new Swiper(".tourGallery .tourGallery__main", {
                spaceBetween: 10,
                navigation: {
                    nextEl: ".tourGallery__main .swiper-button-next",
                    prevEl: ".tourGallery__main .swiper-button-prev",
                },
                thumbs: {
                    swiper: tourThumbs,
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                speed: 500,
            });
            $(".tourGallery__main").on("mouseenter", () => {
                tourGalleryMain.autoplay.stop();
            }).on("mouseleave", () => {
                tourGalleryMain.autoplay.start();
            });
        }

        $(document).on('click', '.hotelPrice__btn, .cruisePrice__btn', function (e) {
            e.preventDefault();
            $('.hotelPrice__btn, .cruisePrice__btn').removeClass('active');
            $(this).addClass('active');
            const location = $(this).data('location');
            let resultsContainer = $('.hotelPrice__grid, .cruisePrice__grid');
            let btnTerm = $('.hotelPrice__link, .cruisePrice__link');
            $.ajax({
                type: 'POST',
                url: ajax_object.ajax_url,
                data: {
                    action: 'load_hotel_minprice',
                    nonce: ajax_object.nonce,
                    location: location
                },
                beforeSend: function () {
                    resultsContainer.html('<p>Loading hotel list...</p>');
                },
                success: function (response) {
                    if (response.success) {
                        resultsContainer.html(response.data.html);
                        btnTerm.attr('href', response.data.term_link);
                    } else {
                        resultsContainer.html(`<p>${response.data.message}</p>`);
                    }
                },
            });
        });

        $(document).on('click', '.hotelTrend__btn, .cruiseTrend__btn', function (e) {
            e.preventDefault();
            $('.hotelTrend__btn, .cruiseTrend__btn').removeClass('active');
            $(this).addClass('active');
            const hotel_type = $(this).data('type');
            let resultsContainer = $('.hotelTrend__grid, .cruiseTrend__grid');
            let btnTerm = $('.hotelTrend__link, .cruiseTrend__link');
            $.ajax({
                type: 'POST',
                url: ajax_object.ajax_url,
                data: {
                    action: 'load_hotel_trend',
                    nonce: ajax_object.nonce,
                    hotel_type: hotel_type
                },
                beforeSend: function () {
                    resultsContainer.html('<p>Loading hotel list...</p>');
                },
                success: function (response) {
                    if (response.success) {
                        resultsContainer.html(response.data.html);
                        btnTerm.attr('href', response.data.term_link);
                    } else {
                        resultsContainer.html(`<p>${response.data.message}</p>`);
                    }
                },
            });
        });

        if ($('.language-switcher').length) {
            const curWidth = $('.innerLanguage').outerWidth();
            $('.language-switcher').css('transform', 'translate(' + curWidth + 'px, -50%)');
        }

        // Toggle language switcher
        $('.titleLanguage').on('click', function (e) {
            e.preventDefault();
            $(this).parent().toggleClass('show');
        });

        // Click outside to close
        $(document).on('click', function (e) {
            if ($(e.target).closest('.language-switcher').length === 0) {
                $('.language-switcher').removeClass('show');
            }
        });

        $(window).on('scroll load', function () {
            if ($('.figureNumber').length) {
                $('.figureNumber').each(function () {
                    var $this = $(this);
                    var position = $this.offset().top;
                    var scrollPosition = $(window).scrollTop() + $(window).height();
                    // Chạy khi phần tử xuất hiện trong màn hình
                    if (position < scrollPosition) {
                        runCounter($this);
                    }
                });
            }
        });

        function runCounter($element) {
            if (!$element.hasClass("counted")) {
                var numberString = $element.html();
                var cleanedNumberString = numberString.replace(/\./g, '');
                var targetNumber = parseInt(cleanedNumberString, 10);

                if (!isNaN(targetNumber)) {
                    $element.addClass("counted");
                    $({ countNum: 0 }).animate({ countNum: targetNumber }, {
                        duration: 3000,
                        easing: "linear",
                        step: function () {
                            let currentNum = Math.floor(this.countNum);
                            let formattedNum = currentNum.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            });
                            $element.text(formattedNum);
                        },
                        complete: function () {
                            let formattedTarget = targetNumber.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            });
                            $element.text(formattedTarget);
                        }
                    });
                } else {
                    console.error("Error: Cannot convert '" + numberString + "' to a valid number.");
                }
            }
        }

        setTimeout(function () {
            AOS.init({ disable: 'mobile', once: true });

            if ($('.tourGallery__main a[data-fancybox]').length) {
                Fancybox.bind('.tourGallery__main a[data-fancybox]', {
                    Carousel: {
                        Zoomable: {
                            Panzoom: {
                                clickAction: "iterateZoom",
                                maxScale: 2,
                            },
                        },
                    },
                });
            }

            if ($('.sf-field-search .sf-input-text').length) {
                $('.sf-field-search .sf-input-text').addClass('form-control');
            }
            if ($('.sf-field-sort_order .sf-input-select').length) {
                $('.sf-field-sort_order .sf-input-select').addClass('form-select');
            }
        }, 500);

        if ($('.moreInfoRoom').length) {
            $('.moreInfoRoom').each(function () {
                $(this).on('click', function (e) {
                    e.preventDefault();
                    const btnTarget = $(this);
                    const roomId = btnTarget.data('room');
                    $.ajax({
                        type: 'POST',
                        url: ajax_object.ajax_url,
                        data: {
                            action: 'load_info_room',
                            nonce: ajax_object.nonce,
                            room_id: roomId
                        },
                        beforeSend: function () {
                            btnTarget.html('Loading data...');
                        },
                        success: function (response) {
                            if (response.success) {
                                btnTarget.html('Room Information');
                                $('.modalRoom .modal-body').html(response.data.html);
                                const roomThumbs = new Swiper(".roomGallery__thumbs", {
                                    spaceBetween: 10,
                                    slidesPerView: 3,
                                    watchSlidesProgress: true,
                                });
                                const roomImages = new Swiper(".roomGallery__images", {
                                    spaceBetween: 10,
                                    navigation: {
                                        nextEl: ".roomGallery__images .swiper-button-next",
                                        prevEl: ".roomGallery__images .swiper-button-prev",
                                    },
                                    thumbs: {
                                        swiper: roomThumbs,
                                    },
                                });
                                $('#modalRoom').modal('show');
                            } else {
                                btnTarget.html('No further information for this room');
                            }
                        },
                    });
                });
            });
        }

        if ($('.hotelNav').length) {
            // Lấy phần tử thanh điều hướng (sử dụng $ để ký hiệu biến chứa đối tượng jQuery)
            const $nav = $('.hotelNav');
            // Lấy vị trí ban đầu của thanh nav
            const stickyOffset = $nav.offset().top;

            // Gắn sự kiện scroll vào cửa sổ trình duyệt
            $(window).on('scroll', function () {
                // Lấy vị trí cuộn hiện tại
                let scrollPos = $(window).scrollTop();

                // So sánh vị trí cuộn với vị trí ban đầu của nav
                if (scrollPos > stickyOffset) {
                    // Nếu đã cuộn qua nav, thêm class 'fixed'
                    $nav.addClass('fixed');
                } else {
                    // Nếu chưa, xóa class 'fixed'
                    $nav.removeClass('fixed');
                }
            });
        }

        if ($('.tourPageNav__item').length) {
            const $navItems = $('.tourPageNav__item');
            const $header = $('.header');
            const $tourNav = $('.tourPageNav');
            const headerHeight = $header.length ? $header.outerHeight() : 0;
            const tourNavHeight = $tourNav.length ? $tourNav.outerHeight() : 0;
            const navOffset = headerHeight + tourNavHeight + 8;

            $navItems.on('click', function (event) {
                event.preventDefault();
                const hash = this.hash;
                if (hash && $(hash).length) {
                    $('html, body').animate({
                        scrollTop: $(hash).offset().top - navOffset
                    });
                }
            });

            $(window).on('scroll.tourPageNavSpy', function () {
                const scrollPos = $(window).scrollTop();
                let $current = null;
                $navItems.each(function () {
                    const $ref = $($(this).attr('href'));
                    if (!$ref.length) {
                        return;
                    }
                    const top = $ref.offset().top;
                    if (top <= scrollPos + navOffset + 4) {
                        $current = $(this);
                    }
                });
                if ($current && $current.length) {
                    $navItems.removeClass('active');
                    $current.addClass('active');
                }
            });
        }

        if ($('.hotelNav__item').length) {
            const $navItems = $('.hotelNav__item');
            const $header = $('.header'); // Hoặc selector của header của bạn, ví dụ: $('.site-header')

            // Tính toán khoảng cách offset (chiều cao header + 12px)
            const headerHeight = $header.outerHeight();
            const offset = headerHeight + 12;

            // --- TÍNH NĂNG 1: CLICK ĐỂ CUỘN MƯỢT ---
            $navItems.on('click', function (event) {
                event.preventDefault();
                const hash = this.hash;

                if (hash !== "" && $(hash).length) {
                    let targetPosition = $(hash).offset().top - offset;
                    $('html, body').animate({
                        scrollTop: targetPosition
                    });
                }
            });

            // --- TÍNH NĂNG 2: CUỘN ĐỂ ACTIVE (SCROLLSPY) ---
            $(window).on('scroll', function () {
                // Lấy vị trí cuộn hiện tại
                let scrollPos = $(window).scrollTop();

                // Duyệt qua từng item trong nav
                $navItems.each(function () {
                    let currentLink = $(this);
                    let refElement = $(currentLink.attr('href'));

                    // Kiểm tra xem khu vực của item này có đang trong tầm nhìn không
                    // Điều kiện: Vị trí của khu vực <= Vị trí cuộn + offset VÀ Vị trí của khu vực + chiều cao của nó > Vị trí cuộn + offset
                    if (refElement.length) {
                        if (refElement.position().top <= scrollPos + offset && refElement.position().top + refElement.outerHeight() > scrollPos + offset) {
                            $navItems.removeClass('active');
                            currentLink.addClass('active');
                        } else {
                            currentLink.removeClass('active');
                        }
                    }
                });

                // Xử lý trường hợp ở trên cùng hoặc dưới cùng của trang
                // Nếu không có item nào được active, hãy active item đầu tiên nếu đang ở gần đầu trang
                if ($('.hotelNav__item.active').length === 0 && scrollPos < $($navItems.first().attr('href')).offset().top) {
                    $navItems.first().addClass('active');
                }
            });
        }

        if ($('.btnSelectRoom').length) {
            const $navItems = $('.btnSelectRoom');
            const $header = $('.header');

            // Tính toán khoảng cách offset (chiều cao header + 12px)
            const headerHeight = $header.outerHeight();
            const offset = headerHeight + 12;

            // --- TÍNH NĂNG 1: CLICK ĐỂ CUỘN MƯỢT ---
            $navItems.on('click', function (event) {
                event.preventDefault();
                const hash = $(this).data('target');

                if (hash !== "" && $(hash).length) {
                    let targetPosition = $(hash).offset().top - offset;
                    $('html, body').animate({
                        scrollTop: targetPosition
                    });
                }
            });
        }

        //Xử lý booking Hotel (inquiry)
        if ($('#modalBookRoom').length) {
            $('#modalBookRoom').on('show.bs.modal', function (e) {
                const button = $(e.relatedTarget);
                const roomId = button.data('id');
                const roomName = button.data('title');

                $(this).find('.modalBookRoom__title').text(roomName);
                $(this).find('input[name="room_id"]').val(roomId);
            });
        }

        if ($('#bookroom-success-toast').length) {
            // Lấy các tham số từ URL hiện tại
            const urlParams = new URLSearchParams(window.location.search);
            const bookingStatus = urlParams.get('booking_inquiry');

            if (bookingStatus) {
                const toastEl = $('#bookroom-success-toast');
                const toastBody = toastEl.find('.toast-body');
                let message = '';

                // Chọn nội dung thông báo dựa trên trạng thái
                if (bookingStatus == 'success') {
                    message = 'Booking successful. We will contact you as soon as possible.';
                } else {
                    message = 'The system is having some problems, please try again later.';
                }

                // Nếu có nội dung, cập nhật và hiển thị Toast
                if (message && toastEl) {
                    toastBody.text(message);
                    $('#modalBookRoom').modal('hide');
                    toastEl.toast('show');
                }
            }
        }

        // Xử lý booking hotel (payment)
        if ($('#modalPayRoom').length) {
            const modalPayRoom = $('#modalPayRoom');
            const form = $('#hotelBookingForm');
            const messagesDiv = $('#live-booking-messages');
            const submitButton = $('#btn-proceed-payment');
            const numRoomsInput = $('#num_rooms');
            const numAdultsInput = $('#num_adults');
            const numChildrenInput = $('#num_children');
            const datePickerElement = form.find('#booking_checkin');
            const durationSelect = form.find('#booking_duration');

            let maxAdultsBase = 1;
            let maxChildBase = 0;

            let maxAdults = 1;
            let maxChildren = 0;
            
            let price2Days = 0;
            let price3Days = 0;
            let currentBasePrice = 0;

            function validateOccupancy() {
                const inputAdults = parseInt(numAdultsInput.val()) || 1;
                const inputChildren = parseInt(numChildrenInput.val()) || 0;
                const totalInput = inputAdults + inputChildren;
                const maxTotal = maxAdults + maxChildren;

                if (inputAdults > maxAdults) {
                    messagesDiv.html('<p class="text-danger">Exceeded maximum adults allowed (' + maxAdults + '). Please increase the number of rooms.</p>');
                    return false;
                }
                if (inputChildren > maxChildren && inputAdults < maxAdults && totalInput > maxTotal) {
                    messagesDiv.html('<p class="text-danger">Exceeded maximum children allowed (' + maxChildren + '). Please increase the number of rooms.</p>');
                    return false;
                }
                if (totalInput > maxTotal) {
                    messagesDiv.html('<p class="text-danger">Exceeded maximum total occupants allowed (' + maxTotal + '). Please increase the number of rooms.</p>');
                    return false;
                }
                return true;
            }

            function updateModalPrices() {
                let addonsPrice = 0;
                const numAdult = parseInt(numAdultsInput.val()) || 1;
                const numChild = parseInt(numChildrenInput.val()) || 0;
                const totalPax = numAdult + numChild;
                const numRooms = parseInt(numRoomsInput.val()) || 1;
                const duration = durationSelect.val();
                
                let nights = (duration === '3_days') ? 2 : 1;
                
                // Cập nhật giá phòng cơ bản theo số phòng và loại ngày
                if (duration === '3_days') {
                    currentBasePrice = price3Days * numRooms;
                } else {
                    currentBasePrice = price2Days * numRooms;
                }

                form.find('.addon-checkbox').each(function() {
                    if ($(this).is(':checked')) {
                        const priceBase = parseFloat($(this).attr('data-price')) || 0;
                        const priceType = $(this).attr('data-price-type') || 'fixed';
                        
                        if (priceType === 'per_person') {
                            addonsPrice += priceBase * totalPax;
                        } else if (priceType === 'per_day') {
                            addonsPrice += priceBase * nights;
                        } else {
                            addonsPrice += priceBase;
                        }
                    }
                });

                const totalPrice = currentBasePrice + addonsPrice;

                $('#modal-base-price').text('$' + Math.round(currentBasePrice).toLocaleString());
                $('#modal-addons-price').text('+$' + Math.round(addonsPrice).toLocaleString());
                $('#modal-total-price').text('$' + Math.round(totalPrice).toLocaleString());
            }

            function checkRequirements() {
                const checkin = datePickerElement.val();
                const numRooms = numRoomsInput.val();
                const roomId = form.find('input[name="room_id"]').val();

                maxAdults = maxAdultsBase * numRooms;
                maxChildren = maxChildBase * numRooms;

                if (!validateOccupancy()) {
                    submitButton.prop('disabled', true);
                    updateModalPrices();
                    return; 
                }

                if (!checkin || !numRooms || !roomId) {
                    submitButton.prop('disabled', true);
                    messagesDiv.empty();
                    updateModalPrices();
                    return;
                }

                messagesDiv.html('');
                submitButton.prop('disabled', false);
                updateModalPrices();
            }

            modalPayRoom.on('show.bs.modal', function (e) {
                const button = $(e.relatedTarget);
                const roomId = button.data('id');
                const roomName = button.data('title');
                const roomAdult = button.data('numadult');
                const roomChild = button.data('numchild');
                
                price2Days = parseFloat(button.attr('data-price-2days')) || 0;
                price3Days = parseFloat(button.attr('data-price-3days')) || 0;

                maxAdults = maxAdultsBase = parseInt(roomAdult) || 1;
                maxChildren = maxChildBase = parseInt(roomChild) || 0;

                modalPayRoom.find('.modalPayRoom__title').text(roomName);
                modalPayRoom.find('.numAdult').text(roomAdult);
                modalPayRoom.find('.numChild').text(roomChild);
                modalPayRoom.find('input[name="room_id"]').val(roomId);

                checkRequirements();

                datePickerElement.off('change').on('change', function () {
                    checkRequirements();
                });
                
                durationSelect.off('change').on('change', function () {
                    checkRequirements();
                });

                // Khi thay đổi checkbox dịch vụ
                form.off('change', '.addon-checkbox').on('change', '.addon-checkbox', updateModalPrices);

                //Khi thay đổi số người
                $('.personInput').off('input change').on('input change', function() {
                    if (validateOccupancy()) {
                        updateModalPrices();
                    }
                });

                // Khi thay đổi số phòng
                numRoomsInput.off('input change').on('input change', checkRequirements);
            });

            form.on('submit', function (e) {
                e.preventDefault();

                const hotelId = form.find('input[name="hotel_id"]').val();
                const roomId = form.find('input[name="room_id"]').val();
                const checkIn = datePickerElement.val();
                const duration = durationSelect.val();
                const numRooms = numRoomsInput.val();
                const numAdult = numAdultsInput.val();
                const numChild = numChildrenInput.val();
                
                let checkoutDate = new Date(checkIn);
                if (duration === '3_days') {
                    checkoutDate.setDate(checkoutDate.getDate() + 2);
                } else {
                    checkoutDate.setDate(checkoutDate.getDate() + 1);
                }
                const checkOut = checkoutDate.toISOString().split('T')[0];

                submitButton.prop('disabled', true).text('Redirecting...');

                const paymentPageUrl = new URL(ajax_object.checkout_url);
                paymentPageUrl.searchParams.append('hotel_id', hotelId);
                paymentPageUrl.searchParams.append('room_id', roomId);
                paymentPageUrl.searchParams.append('check_in', checkIn);
                paymentPageUrl.searchParams.append('check_out', checkOut);
                paymentPageUrl.searchParams.append('num_rooms', numRooms);
                paymentPageUrl.searchParams.append('num_adults', numAdult);
                paymentPageUrl.searchParams.append('num_children', numChild);
                if (duration) {
                    paymentPageUrl.searchParams.append('duration', duration);
                }

                const addonsParams = [];
                form.find('.addon-checkbox:checked').each(function() {
                    const price = parseFloat($(this).data('price')) || 0;
                    const id = $(this).val();
                    addonsParams.push(id + ':' + price);
                });
                
                if (addonsParams.length > 0) {
                    paymentPageUrl.searchParams.append('addons', addonsParams.join(','));
                }

                window.location.href = paymentPageUrl.toString();
            });
        }

        if ($('.checkoutRoomImages').length) {
            const checkoutRoomImages = new Swiper(".checkoutRoomImages", {
                spaceBetween: 10,
                navigation: {
                    nextEl: ".checkoutRoomImages .swiper-button-next",
                    prevEl: ".checkoutRoomImages .swiper-button-prev",
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 800,
            });
        }

        if ($('input[name="extra[]"]').length) {
            const $basePriceElement = $('[data-base]');
            const $taxElement = $('[data-tax]');
            const $roomTotalElement = $('[data-room-total]');
            const $finalTotalElement = $('[data-total]');
            const $finalTotalInput = $('[name="total_price"]');
            const initialBasePrice = parseFloat($basePriceElement.data('base')) || 0;
            const taxPercentage = parseFloat($taxElement.data('tax')) || 0;
            const locale = 'en-US';
            const nf = function (n) {
                return new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n);
            };

            $('input[name="extra[]"]').on('change', function () {
                let extrasTotal = 0;
                const extrasData = [];

                $('input[name="extra[]"]:checked').each(function () {
                    const extraTitle = $(this).siblings('label').find('.text').text();
                    const extraVal = parseFloat($(this).val()) || 0;
                    extrasTotal += extraVal;
                    extrasData.push({ title: extraTitle, price: extraVal });
                });

                $('input[name="extras"]').val(JSON.stringify(extrasData));

                const currentRoomTotal = initialBasePrice + extrasTotal;
                const currentTaxAmount = currentRoomTotal * (taxPercentage / 100);
                const currentFinalTotal = currentRoomTotal + currentTaxAmount;
                const roomTotalDisplay = nf(currentRoomTotal) + ' USD';
                const taxAmountDisplay = nf(currentTaxAmount) + ' USD';
                const finalTotalDisplay = nf(currentFinalTotal) + ' USD';

                $basePriceElement.attr('data-base', initialBasePrice + extrasTotal).html(roomTotalDisplay);
                $roomTotalElement.attr('data-room-total', initialBasePrice + extrasTotal).html(roomTotalDisplay);
                $taxElement.html(taxAmountDisplay);
                $finalTotalElement.attr('data-total', currentFinalTotal).html(finalTotalDisplay);
                $finalTotalInput.val(currentFinalTotal);
            });

            $('input[name="extra[]"]').trigger('change');
        }

        window.addEventListener('load', function () {
            const marqueeContainer = document.getElementById('myMarquee');
            if (!marqueeContainer) {
                console.error("Marquee container '#myMarquee' not found.");
                return;
            }

            const marqueeWrapper = marqueeContainer.querySelector('.marqueeContainer');
            if (!marqueeWrapper) {
                console.error("Marquee wrapper '.marqueeContainer' not found inside '#myMarquee'.");
                return;
            }

            const originalItems = Array.from(marqueeWrapper.children);
            if (originalItems.length === 0) {
                console.warn('Marquee wrapper has no child elements.');
                return;
            }

            const speed = 80;
            const direction = -1;
            const pauseOnHover = true;

            while (marqueeWrapper.children.length > originalItems.length) {
                marqueeWrapper.removeChild(marqueeWrapper.lastChild);
            }

            originalItems.forEach(function (item) {
                const clone = item.cloneNode(true);
                marqueeWrapper.appendChild(clone);
            });

            requestAnimationFrame(function () {
                const totalWidth = marqueeWrapper.scrollWidth;
                const resetWidth = totalWidth / 2;

                if (resetWidth <= 0 || resetWidth <= marqueeContainer.offsetWidth) {
                    while (marqueeWrapper.children.length > originalItems.length) {
                        marqueeWrapper.removeChild(marqueeWrapper.lastChild);
                    }
                    return;
                }

                const duration = speed > 0 ? (resetWidth / speed) * 1000 : 0;

                if (marqueeWrapper.animation) {
                    marqueeWrapper.animation.cancel();
                }

                if (duration > 0) {
                    const animation = marqueeWrapper.animate(
                        [
                            { transform: 'translateX(25px)' },
                            { transform: 'translateX(' + direction * resetWidth + 'px)' }
                        ],
                        {
                            duration: duration,
                            iterations: Infinity,
                            easing: 'linear'
                        }
                    );

                    marqueeWrapper.animation = animation;

                    if (pauseOnHover) {
                        const pauseAnimation = function () {
                            if (marqueeWrapper.animation) {
                                marqueeWrapper.animation.pause();
                            }
                        };
                        const playAnimation = function () {
                            if (marqueeWrapper.animation) {
                                marqueeWrapper.animation.play();
                            }
                        };

                        marqueeContainer.addEventListener('mouseenter', pauseAnimation);
                        marqueeContainer.addEventListener('mouseleave', playAnimation);
                        marqueeContainer.animationListeners = { pauseAnimation: pauseAnimation, playAnimation: playAnimation };
                    }
                } else {
                    while (marqueeWrapper.children.length > originalItems.length) {
                        marqueeWrapper.removeChild(marqueeWrapper.lastChild);
                    }
                }
            });
        });
    });
})(jQuery);
; (() => {
    'use strict'

    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.needs-validation')

    // Loop over them and prevent submission
    Array.from(forms).forEach(form => {
        form.addEventListener('submit', event => {
            if (!form.checkValidity()) {
                event.preventDefault()
                event.stopPropagation()
            }

            form.classList.add('was-validated')
        }, false)
    })
})()


function initMap() {
    const mapModal = document.getElementById('modalViewMap');
    if (mapModal) {
        mapModal.addEventListener('show.bs.modal', function (event) {
            const button = event.relatedTarget;

            // Lấy thông tin vị trí
            const lat = parseFloat(button.getAttribute('data-lat'));
            const lng = parseFloat(button.getAttribute('data-long'));
            const location = { lat: lat, lng: lng };

            // --- PHẦN CẬP NHẬT BẮT ĐẦU TẠI ĐÂY ---

            // 1. Lấy thông tin tùy chỉnh từ các thuộc tính data-*
            const title = button.getAttribute('data-title');
            const imageUrl = button.getAttribute('data-img');
            // Chuyển đổi hotelClass từ chuỗi sang số
            const hotelClass = parseInt(button.getAttribute('data-class'), 10);

            // 2. Tạo chuỗi HTML cho các ngôi sao đánh giá
            let starsHTML = '';
            if (!isNaN(hotelClass)) { // Chỉ chạy nếu hotelClass là một con số hợp lệ
                for (let i = 0; i < hotelClass; i++) {
                    starsHTML += '<span>★</span>'; // Ký tự ngôi sao
                }
            }

            // 3. Xây dựng toàn bộ nội dung HTML cho InfoWindow
            const infoContent = `
                <div class="custom-infowindow d-flex gap-2">
                    <img src="${imageUrl}" alt="${title}" class="infowindow-img d-block flex-shrink-0">
                    <div class="infowindow-content flex-grow-1 d-flex flex-column row-gap-2">
                        <h3 class="infowindow-title mb-0">${title}</h3>
                        <div class="infowindow-class">
                            ${starsHTML}
                        </div>
                    </div>
                </div>
            `;

            // --- KẾT THÚC PHẦN CẬP NHẬT ---

            const mapDiv = document.getElementById('mainMap');
            mapDiv.focus();

            const map = new google.maps.Map(mapDiv, {
                zoom: 15,
                center: location,
                mapId: 'DEMO_MAP_ID'
            });

            const marker = new google.maps.marker.AdvancedMarkerElement({
                position: location,
                map: map,
            });

            // Tạo InfoWindow với nội dung HTML tùy chỉnh
            const infowindow = new google.maps.InfoWindow({
                content: infoContent,
                maxWidth: 300 // Giới hạn chiều rộng tối đa
            });

            infowindow.open(map, marker);

            marker.addEventListener('click', (e) => {
                infowindow.open(map, marker);
            });
        });
    }
}
initMap();

